// extracted by mini-css-extract-plugin
export default {"page":"PageWithToolbar_page__heJGD","content":"PageWithToolbar_content__2jscA","toolbar":"PageWithToolbar_toolbar__RmF7n","fixed":"PageWithToolbar_fixed__pSChx"};